export enum EditGroupModalView {
  add = "add",
  edit = "edit",
}
